

































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Player extends Vue {
    playing = false
    mutes = false

    get audio () {
        return this.$store.getters['getAudio']
    }
    get current () {
        return this.$store.getters['getCurrent']
    }
    get isShuffle () {
        return this.$store.getters['getShuffle']
    }
    get isRepeat () {
        return this.$store.getters['getRepeat']
    }
    get convertDurationToMinutes() {
        return (Math.round(this.audio.duration)/60).toFixed(2)
    }
    get convertCurrentTimeToMinutes() {
        return (Math.round(this.audio.currentTime)/60).toFixed(2)
    }

    convertTime (secs: any) {
        const min = Math.floor(secs / 60);
        const sec = secs % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    shuffle() {
        this.$store.commit('setShuffle')
    }
    repeat() {
        this.$store.commit('setRepeat')
    }
    play () {
        this.audio.play()
        this.playing = !this.playing
    }
    pause () {
        this.audio.pause()
        this.playing = !this.playing
    }
    playNext () {
        this.$store.commit('playNextSong')
        this.audio.play()
    }
    playPrevious () {
        this.$store.commit('playPreviousSong')
        this.audio.play()
    }
    times = '00:00'
    slider () {
        setInterval(() => {
            if(this.audio.ended) {
                this.playNext()
            }
            this.times = this.convertTime(Math.round(this.audio.currentTime))
            const c = document.getElementById('time') as any
            const d = document.getElementById('mobile-time') as any
            c.value = Math.round(this.audio.currentTime)
            d.value = Math.round(this.audio.currentTime)
        }, 1000)
    }
    mute () {
        this.audio.muted = !this.audio.muted
        this.mutes = !this.mutes
    }

    mounted() {
        this.slider()
    }

}
